"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  default: () => createAuthClient
});
module.exports = __toCommonJS(src_exports);

// ../../node_modules/jwt-decode/build/jwt-decode.esm.js
function e(e2) {
  this.message = e2;
}
e.prototype = new Error(), e.prototype.name = "InvalidCharacterError";
var r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r2) {
  var t2 = String(r2).replace(/=+$/, "");
  if (t2.length % 4 == 1)
    throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var n2, o2, a = 0, i = 0, c = ""; o2 = t2.charAt(i++); ~o2 && (n2 = a % 4 ? 64 * n2 + o2 : o2, a++ % 4) ? c += String.fromCharCode(255 & n2 >> (-2 * a & 6)) : 0)
    o2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o2);
  return c;
};
function t(e2) {
  var t2 = e2.replace(/-/g, "+").replace(/_/g, "/");
  switch (t2.length % 4) {
    case 0:
      break;
    case 2:
      t2 += "==";
      break;
    case 3:
      t2 += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(e3) {
      return decodeURIComponent(r(e3).replace(/(.)/g, function(e4, r2) {
        var t3 = r2.charCodeAt(0).toString(16).toUpperCase();
        return t3.length < 2 && (t3 = "0" + t3), "%" + t3;
      }));
    }(t2);
  } catch (e3) {
    return r(t2);
  }
}
function n(e2) {
  this.message = e2;
}
function o(e2, r2) {
  if ("string" != typeof e2)
    throw new n("Invalid token specified");
  var o2 = true === (r2 = r2 || {}).header ? 0 : 1;
  try {
    return JSON.parse(t(e2.split(".")[o2]));
  } catch (e3) {
    throw new n("Invalid token specified: " + e3.message);
  }
}
n.prototype = new Error(), n.prototype.name = "InvalidTokenError";
var jwt_decode_esm_default = o;

// src/client.ts
var LOCAL_AUTH_KEY = "apc_token";
var AUTH_QUERY_PARAM = "apc_auth";
var RETURN_URL_PARAM = "returnUrl";
var SPOOF_QUERY_PARAM = "view_as";
var SWITCH_QUERY_PARAM = "account";
var REFRESH_INTERVAL = 30 * 60 * 1e3;
function removeQueryParam(name) {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.delete(name);
  window.history.replaceState(null, "", `?${queryParams.toString()}`);
}
function getAccountId(token) {
  const {
    claims: { account_id: accountId }
  } = jwt_decode_esm_default(token);
  return accountId;
}
function getUserId(token) {
  const { uid } = jwt_decode_esm_default(token);
  return uid;
}
function isSpoofing(token) {
  const {
    claims: { spoofing }
  } = jwt_decode_esm_default(token);
  return Boolean(spoofing);
}
function sendBuilderMessage(crxId, action, value) {
  try {
    if (window.chrome) {
      window.chrome.runtime.sendMessage(crxId, {
        action,
        value
      });
    }
  } catch {
  }
}
function createAuthClient(baseUrl, authUrl, crxId) {
  let storedToken;
  const tokenQueue = [];
  function storeToken(token) {
    var _a;
    storedToken = token;
    localStorage.setItem(
      LOCAL_AUTH_KEY,
      JSON.stringify({ token: storedToken })
    );
    while (tokenQueue.length > 0) {
      (_a = tokenQueue.shift()) == null ? void 0 : _a(storedToken);
    }
    return token;
  }
  function setBuilderToken(token) {
    sendBuilderMessage(crxId, "set-account", { token });
    return token;
  }
  function logOutBuilder() {
    sendBuilderMessage(crxId, "log-out");
  }
  async function fetchAuthAPI(token, action, body = {}) {
    const response = await fetch(`${baseUrl}/v1/${action}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      method: "POST",
      body: JSON.stringify({ jwt_token: token, ...body })
    });
    if (!response.ok) {
      throw new Error("Response not ok");
    }
    const json = await response.json();
    if (Object.hasOwn(json, "payload")) {
      const {
        payload: { firebase: parsedToken2 }
      } = json;
      return parsedToken2;
    }
    const { firebase: parsedToken } = json;
    return parsedToken;
  }
  function redirectToAuth(path, returnUrl) {
    const redirectParams = new URLSearchParams();
    if (returnUrl) {
      redirectParams.set(RETURN_URL_PARAM, returnUrl);
    }
    window.location.replace(`${authUrl}${path}?${redirectParams.toString()}`);
  }
  function refresh(token) {
    return fetchAuthAPI(token, "web/refresh");
  }
  async function spoof(token, id) {
    const spoofedToken = await fetchAuthAPI(token, "web/spoof", {
      account_id: id
    });
    storeToken(spoofedToken);
    setBuilderToken(spoofedToken);
    return spoofedToken;
  }
  async function despoof(token) {
    const despoofedToken = await fetchAuthAPI(token, "web/despoof");
    storeToken(despoofedToken);
    setBuilderToken(despoofedToken);
    return despoofedToken;
  }
  async function switchAccount(token, id) {
    const switchedToken = await fetchAuthAPI(token, `accounts/${id}/switch`);
    storeToken(switchedToken);
    setBuilderToken(switchedToken);
    return switchedToken;
  }
  async function getToken() {
    if (storedToken) {
      return storedToken;
    }
    return new Promise((res) => {
      tokenQueue.push(res);
    });
  }
  async function initialize() {
    const queryParams = new URLSearchParams(window.location.search);
    const queryToken = queryParams.get(AUTH_QUERY_PARAM);
    if (queryToken) {
      removeQueryParam(AUTH_QUERY_PARAM);
    }
    const { token: localToken } = JSON.parse(
      localStorage.getItem(LOCAL_AUTH_KEY) || "{}"
    );
    const initialToken = queryToken || localToken;
    try {
      const refreshedToken = await refresh(initialToken);
      let resolvedToken = refreshedToken;
      if (queryParams.has(SPOOF_QUERY_PARAM) || queryParams.has(SWITCH_QUERY_PARAM)) {
        const despoofedToken = isSpoofing(refreshedToken) ? await despoof(refreshedToken) : refreshedToken;
        if (queryParams.has(SPOOF_QUERY_PARAM)) {
          const spoofId = queryParams.get(SPOOF_QUERY_PARAM);
          removeQueryParam(SPOOF_QUERY_PARAM);
          resolvedToken = await spoof(despoofedToken, spoofId);
        }
        if (queryParams.has(SWITCH_QUERY_PARAM)) {
          const switchId = queryParams.get(SWITCH_QUERY_PARAM);
          removeQueryParam(SWITCH_QUERY_PARAM);
          resolvedToken = await switchAccount(despoofedToken, switchId);
        }
      }
      storeToken(resolvedToken);
      setBuilderToken(resolvedToken);
      setInterval(async () => {
        storeToken(await refresh(await getToken()));
      }, REFRESH_INTERVAL);
    } catch {
      redirectToAuth("", window.location.href);
    }
  }
  initialize();
  return {
    logout: () => {
      localStorage.removeItem(LOCAL_AUTH_KEY);
      logOutBuilder();
      redirectToAuth("/logout");
    },
    getToken,
    async getAccountId() {
      return getAccountId(await getToken());
    },
    async getUserId() {
      return getUserId(await getToken());
    },
    async spoof(id) {
      await spoof(await getToken(), id);
      window.location.reload();
    },
    async despoof() {
      await despoof(await getToken());
      window.location.reload();
    },
    async isSpoofing() {
      return isSpoofing(await getToken());
    },
    async switchAccount(id) {
      await switchAccount(await getToken(), id);
      window.location.reload();
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
//# sourceMappingURL=index.js.map